var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from 'react';
import './KodanshaEmail.scss';
import { isiOS } from '../../../utils/utils';
// eslint-disable-next-line react/display-name
var KodanshaEmail = forwardRef(function (_a, ref) {
    var onChange = _a.onChange, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b, label = _a.label, onBlur = _a.onBlur, onFocus = _a.onFocus, ariaLabeledBy = _a.ariaLabeledBy, _c = _a.placeHolder, placeHolder = _c === void 0 ? '' : _c, _d = _a.name, name = _d === void 0 ? '' : _d, _e = _a.errorMessage, errorMessage = _e === void 0 ? '' : _e, _f = _a.withFocus, withFocus = _f === void 0 ? false : _f, _g = _a.styles, styles = _g === void 0 ? '' : _g, _h = _a.autocomplete, autocomplete = _h === void 0 ? '' : _h, _j = _a.inputStyles, inputStyles = _j === void 0 ? '' : _j, _k = _a.value, value = _k === void 0 ? '' : _k, _l = _a.active, active = _l === void 0 ? true : _l, _m = _a.type, type = _m === void 0 ? 'text' : _m, _o = _a.instructions, instructions = _o === void 0 ? [] : _o, onEnterPushed = _a.onEnterPushed, onSubmit = _a.onSubmit;
    var _p = __read(useState(value), 2), inputValue = _p[0], setInputValue = _p[1];
    var inputRef = useRef(null);
    var idRef = useRef("".concat(label, "-input-").concat(Math.random()));
    var onInputClicked = function (e) {
        e.stopPropagation();
    };
    useEffect(function () {
        var _a;
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            inputRef.current = ref === null || ref === void 0 ? void 0 : ref.current;
        }
        if (withFocus) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, []);
    var onInputChanged = function (e) {
        setInputValue(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    };
    useEffect(function () {
        setInputValue(value);
    }, [value]);
    var onKey = function (e) {
        e.key === 'Enter' && onEnterPushed && onEnterPushed(e);
    };
    return (_jsxs("div", { onClick: onInputClicked, className: "kodansha-email-wrapper ".concat(styles), children: [_jsx("input", { className: "email-input ".concat(inputStyles), placeholder: placeHolder, onChange: onInputChanged, onKeyDown: onKey, "aria-labelledby": ariaLabeledBy !== null && ariaLabeledBy !== void 0 ? ariaLabeledBy : '', id: idRef.current, name: name, onSubmit: onSubmit && onSubmit, autoComplete: autocomplete, onFocus: onFocus, onBlur: onBlur, ref: ref !== null && ref !== void 0 ? ref : inputRef, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : placeHolder, disabled: !active, type: type, value: inputValue, style: {
                    backgroundColor: active === false && '#d7d7d7',
                    border: active === false ? '2px solid #757575' : errorMessage !== '' ? '2px solid red' : '2px solid #000000',
                    color: active === false ? isiOS() ? '#000000' : '#757575' : errorMessage !== '' && 'red',
                } }), errorMessage !== '' && _jsx("span", { className: 'error', children: errorMessage }), instructions !== undefined && instructions.map(function (message, index) {
                return (_jsx("span", { className: 'error', children: message }, index));
            })] }));
});
export default KodanshaEmail;
